<script setup lang="ts">
import { unref } from 'vue';
import { cn } from '../../lib/utils';
import { DataState } from '../../types/types';
import { Skeleton } from '../ui/skeleton';

const props = defineProps<{
  class?: string
  sizingClass?: string
  errorClass?: string
  dataState: DataState
}>()
</script>

<template>
  <Skeleton
    :class="cn('h-5 min-w-14 bg-slate-200', props.class, sizingClass)"
    v-if="unref(dataState.isLoading)"
  />
  <div
    v-else-if="unref(dataState.isError)"
    :class="cn('h-5 min-w-14 bg-gray-200 rounded-md', errorClass, sizingClass)"
  ></div>
  <slot v-else />
</template>
